import { render, staticRenderFns } from "./isDrafts.vue?vue&type=template&id=7d230f04&scoped=true&"
import script from "./isDrafts.vue?vue&type=script&lang=js&"
export * from "./isDrafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d230f04",
  null
  
)

export default component.exports